/*
 * サブシステム名：マスタ管理
 * 機能名：種別マスタ一覧
 */
import DdCustomButton from '@/components/DdCustomButton'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'VwCMstShubetsuList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: { SbtShuruiId: null },
    modeKengen: 0,
    headersKbnSbtShuruiList: header.msysKubunShubetsuShurui,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdDataTable,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader
  },
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    // 区分種別種類
    filteredKubunShubetsuShurui () {
      return this.kubunshubetsushuruiList.filter(function (elem) {
        return elem.kbnSbtKbn === 'S'
      }).map(function (elem) {
        elem.value = elem.kbnSbtShuruiCd
        elem.text = elem.kbnSbtShuruiNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kbnSbtShuruiCd > elem2.kbnSbtShuruiCd) { return 1 }
        if (elem1.kbnSbtShuruiCd === elem2.kbnSbtShuruiCd) { return 0 }
        return -1
      })
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstshubetsu', 'msyskubunshubetsushurui'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstShubetsuList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '種別コード', value: 'sbtCd' },
              { text: '種別表示名', value: 'sbtNm' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'right' },
              { text: '表示フラグ', value: 'hyojiFlgShubetsu' },
              { text: '項目１', value: 'komoku1' },
              { text: '項目２', value: 'komoku2' },
              { text: '項目３', value: 'komoku3' },
              { text: '項目４', value: 'komoku4' },
              { text: '項目５', value: 'komoku5' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              SbtShuruiId: null
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstShubetsuList.savedInputRestorePromise', c)
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstShubetsuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstShubetsuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstShubetsuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstShubetsuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            // 新規作成ボタンの制御
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      this.conditions.SbtShuruiCd = this.getKubunShuruiCd(this.conditions.SbtShuruiId)
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstShubetsu/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              SbtShuruiId: null
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/MstShubetsu/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '種別マスタ一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      if (!this.conditions.SbtShuruiId) {
        this.$refs.SbtShuruiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      this.Effects.loadStart()
      this.transition(0, { id: 0, msysksid: this.conditions.SbtShuruiId })
    },
    searchValidate: function () {
      return true
    },
    onKubunChange: function (e) {
      this.conditions.SbtShuruiCd = this.getKubunShuruiCd(this.conditions.SbtShuruiId)
    },
    getKubunShuruiCd: function (pKbnShuruiId) {
      var kubun = this.filteredKubunShubetsuShurui.filter((t) => {
        return t.id === pKbnShuruiId
      })
      if (kubun.length > 0) {
        return kubun[0].kbnSbtShuruiCd
      }
      return ''
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
